import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=1585e91a&scoped=true&lang=pug"
import script from "./SendMessage.vue?vue&type=script&lang=ts"
export * from "./SendMessage.vue?vue&type=script&lang=ts"
import style0 from "./SendMessage.vue?vue&type=style&index=0&id=1585e91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585e91a",
  null
  
)

export default component.exports